<template>
    <div v-if="visible">
        <v-dialog
            v-model="showDialogue"
            persistent
            max-width="500"
        >
            <v-card
            :loading="form.loading">
                <v-form ref="takePaymentForm" lazy-validation @submit="onSubmit">
                    <v-card-title class="px-3">Take Payment</v-card-title>
                    <v-divider></v-divider>

                    <v-container fluid>
                        <v-row>
                            <v-col md="12" class="pb-0" align="center" justify="center">
                                <div class="mb-5">Confirm a new transaction against a tokenised card.</div>

                                <v-img v-if="formatPaymentBrand" src="@/assets/visa.png" width="200"></v-img>
                                <v-img v-else src="@/assets/mastercard-small.png" width="200"></v-img>

                                <div class="mt-8"><b>Card Number: </b>{{ `${cardData.bin}******${cardData.last4Digits}` }}</div>
                                <div class="mt-2"><b>Card Holder: </b>{{ cardData.holder }}</div>
                                <div class="mt-2"><b>Card Expiry: </b>{{ `${cardData.expMonth}/${cardData.expYear}` }}</div>
                                <div class="mt-2"><b>Add On: </b>{{ cardData.createdAt }}</div>

                                <v-col md="7" class="pb-0 pt-5">
                                    <v-combobox
                                        v-model="form.data.product"
                                        :items="computeProductsList"
                                        item-text="name"
                                        item-value="id"
                                        label="Product (Optional)"
                                        dense
                                        return-object
                                        @change="productHandle"
                                        ></v-combobox>
                                </v-col>

                                <v-col md="7" class="pt-0">
                                    <v-text-field
                                        v-model="form.data.amount"
                                        :rules="rules.required"
                                        required
                                        dense
                                        :label="computedAmountLabel"
                                        class="take-payment-label"
                                    ></v-text-field>
                                </v-col>
                            </v-col>
                            
                            <v-col v-if="alert.show" md="12" class="py-0">
                                <v-alert
                                :type="alert.type"
                                text border="left"
                                dismissible
                                class="mb-2">
                                    <span v-if="alert.code">Code: {{ alert.code }}</span><br v-if="alert.code && alert.desc">
                                    <span v-if="alert.desc">Description: {{ alert.desc }}</span>
                                </v-alert>
                            </v-col>
                        </v-row>
                    </v-container>

                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="error" @click="closeDialogue()">Close</v-btn>
                        <v-btn :disabled="computeIsSubmitDisabled" color="primary" type="submit">Take Payment</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from 'axios';
import { mask } from 'vue-the-mask';

export default {

    props: {
        visible: Boolean,
        client: Object,
        cardData: Object
    },

    beforeMount() {
        console.log(this.client);
        console.log(this.cardData);
    },

    computed: {

        showDialogue() {
            return this.visible ? true : false;
        },

        formatPaymentBrand() {
            return this.cardData.bin.toString().startsWith(4) ? true : false;
        },

        computeProductsList() {

            if(typeof this.client == 'undefined' || !this.client.product || this.client.product.length < 1) {
                return [];
            }
            
            return this.client.product;
        },

        computeIsSubmitDisabled() {
            return this.form.loading || (!this.form.data.amount && !this.form.loading);
        },

        computedAmountLabel() {
            var currency = this.client.crm_config.currency;
            return `Amount (${currency})`;
        },
    },

    directives: { mask },
    
    data() {
        return {

            form: {
                data: {
                    product: null,
                    amount: null,
                },
                response: null,
                loading: false,
            },

            alert: {
                show: false,
                type: null,
                desc: null,
                code: null,
            },

            rules: { required: [ v => !!v || 'Required' ]},
        }
    },

    methods: {

        onSubmit(e) {

            e.preventDefault();

            if(this.$refs.takePaymentForm.validate()) {

                this.form.loading = true;
                this.resetAlert();

                var payload = { 
                    paymentType: 'MOTO',
                    userId: this.$store.state.user.id,

                    client: this.client,
                    card: this.cardData,
                    currency: this.client.crm_config.currency,

                    product: this.form.data.product,
                    amount: this.form.data.amount,
                };

                axios({
                    method: 'post',
                    url: 'recurring-payment-live',
                    data: payload,
                    config: {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        }
                    }
                })
                .then(response => {
                    this.form.loading = false;
                    this.form.response = response.data;

                    this.parseResponse(response.data);

                    this.$emit('getCards');
                    this.$emit('getPayments');
                    this.$emit('getProducts');
                })
                .catch(e => {
                    this.form.loading = false;
                    this.showAlert("error", "There was a problem processing the request.", null);
                    this.errors.push(e)
                })
            }
        },

        parseResponse(data) {
            var resultCode = data.result.code;
            var resultDesc = data.result.description;

            if(resultCode == '000.000.000' || resultCode == '000.100.110') {
                this.$refs.takePaymentForm.reset();
                this.showAlert("success", resultDesc, resultCode);
            } else {
                this.showAlert("error", resultDesc, resultCode);
            }
        },

        showAlert(type, desc, code) {
            this.alert = {
                show: true,
                type: type,
                desc: desc,
                code: code
            };
        },

        resetAlert() {
            this.alert = {
                show: false,
                type: null,
                desc: null,
                code: null,
            };
        },

        resetForm() {
            this.form = {
                data: {
                    product: null,
                    amount: null,
                },
                response: null,
                loading: false,
            };
        },

        closeDialogue() {
            this.resetForm();
            this.resetAlert();
            this.$emit('close', false);
        },
    }
}
</script>

<style>
    .take-payment-label input {
        padding: 0px !important;
    }
</style>